import React, { useEffect, useState } from "react";
import { Formik, useFormikContext } from "formik";
import { Switch } from "@headlessui/react";
import _ from "lodash";
import { useQuery, gql, useMutation } from "@apollo/client";
// import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import BeneficiarySearchNSelect from "../../../Eligibility/components/requestEligibility/BeneficiarySearchNSelect";
import gqlProviders from "../../../../gql/providers";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../../../shared/CustomFilterInput";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function PreAuthInfo({ onChange, refId }) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = useFormikContext();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [providers, setProviders] = useState([]);

  const [subTypes, setSubTypes] = useState([
    { id: "op", name: t("OutPatient") },
    { id: "ip", name: t("InPatient") },
    { id: "emr", name: t("Emergency") },
  ]);

  const [priorities, setPriorities] = useState([
    { id: "stat", name: t("Stat") },
    { id: "normal", name: t("Normal") },
    { id: "deferred", name: t("Deferred") },
  ]);

  const formatProvidersData = (data) => {
    let returnData = [];
    if (data?.length > 0) {
      data.map((item) => {
        returnData.push({
          id: item.id,
          name: item.NameEn,
        });
      });
    } else {
    }
    return returnData;
  };

  const payers = [
    {
      id: 1,
      nameAR: "شركة بوبا العربية للتأمين التعاوني",
      nameEN: t("Bupa Arabia for Cooperative Insurance"),
    },
    {
      id: 2,
      nameAR: "شركة بوبا العربية للتأمين التعاوني",
      nameEN: t("Cooperative Company for Cooperative Insurance"),
    },
    {
      id: 3,
      nameAR: "شركة بوبا العربية للتأمين التعاوني",
      nameEN: t("Al-Rajhi Company for Cooperative Insurance"),
    },
  ];

  const statuses = [
    { id: 1, name: "Processing Complete" },
    { id: 2, name: "Error" },
  ];

  const types = [
    { id: "institutional", name: t("Institutional") },
    { id: "oral", name: t("Dental") },
    { id: "pharmacy", name: t("Pharmacy") },
    { id: "professional", name: t("Professional") },
    { id: "vision", name: t("Optical") },
  ];

  const handleSubType = (val) => {
    if (val == "institutional") {
      setFieldValue("subType", "ip");
      setSubTypes([{ id: "ip", name: t("InPatient") }]);
    } else if (val == "professional") {
      setFieldValue("subType", "op");
      setSubTypes([
        { id: "op", name: t("OutPatient") },
        { id: "emr", name: t("Emergency") },
      ]);
    } else {
      setFieldValue("subType", "op");
      setSubTypes([{ id: "op", name: t("OutPatient") }]);
    }
  };

  useEffect(() => {
    if (values.claimType === "professional" || values.claimType === "oral") {
      setFieldValue(
        "encounterClass",
        values?.encounterClass ? values?.encounterClass : "AMB",
      );
      setFieldValue(
        "serviceEventType",
        values?.serviceEventType ? values?.serviceEventType : "ICSE",
      );
    } else {
      setFieldValue(
        "encounterClass",
        values?.encounterClass ? values?.encounterClass : null,
      );
      setFieldValue(
        "serviceEventType",
        values?.serviceEventType ? values?.serviceEventType : null,
      );
    }
  }, [values.claimType]);

  const addData = (values) => {
    // setShowEligibilityModal(false);
    let data = _.cloneDeep(values);
    // checkEligibility({ variables: { input: data } });
  };
  const formikRef = React.useRef();
  React.useImperativeHandle(refId, () => ({
    Submit: async () => {
      await formikRef.current.submitForm();
    },
  }));

  function watchForm(data) {
    if (onChange) {
      onChange({
        values: data,
      });
    }
  }
  return (
    <div class="personal-data !p-1.5 !mb-2 !shadow-none">
      <div class="personal-title !mb-1.5">
        <div class="inventory-svg">
          <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="34" height="34" rx="8" fill="#F4F6F8"></rect>
            <path
              d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
              fill="#0070C2"
            ></path>
            <path
              d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
              fill="#0070C2"
            ></path>
          </svg>
        </div>
        <div class="personal-head">
          <span>{t("PreAuth Info")}</span>
        </div>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-1.5">
        <CustomFilterInput
          label={t("Date Ordered*")}
          name="dateOrdered"
          type="date"
          value={values.dateOrdered}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.dateOrdered}
          touched={touched.dateOrdered}
        />

        <CustomFilterInput
          label={t("Claim Type*")}
          name="claimType"
          isSelect={true}
          options={types}
          value={values.claimType}
          placeholder={t("Select Type")}
          onChange={(e) => {
            setFieldValue("claimType", e.target.value);
            setFieldValue("supportingInfos", []);
            handleSubType(e.target.value);
          }}
          error={errors.claimType}
          touched={touched.claimType}
        />

        <CustomFilterInput
          label={t("Sub Type")}
          name="subType"
          isSelect={true}
          options={subTypes}
          value={values.subType}
          onChange={handleChange}
          placeholder={t("Select Sub Type")}
          error={errors.subType}
          touched={touched.subType}
        />

        <CustomFilterInput
          label={t("Offline Eligibility Id")}
          name="offlineEligibilityId"
          value={values.offlineEligibilityId}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("Offline Eligibility ID")}
        />

        <CustomFilterInput
          label={t("Eligibility Response Identifier")}
          name="eligibilityResponseIdentifierValue"
          value={values.eligibilityResponseIdentifierValue}
          onChange={handleChange}
          placeholder={t("Eligibility Response Identifier (Value)")}
        />

        <CustomFilterInput
          label={t("Eligibility Response Identifier")}
          name="eligibilityResponseIdentifierUrl"
          value={values.eligibilityResponseIdentifierUrl}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("Eligibility Response Identifier (URL)")}
        />

        <CustomFilterInput
          label={t("Offline Eligibility Date")}
          name="offlineEligibilityDate"
          type="date"
          value={values.offlineEligibilityDate}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("Offline Eligibility Date")}
        />

        <CustomFilterInput
          label={t("Related PreAuth Ref No(s).")}
          name="relatedPreAuthRefNo"
          value={values.relatedPreAuthRefNo}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("Related Preauthorization Reference No(s).")}
        />

        <CustomFilterInput
          label={t("Ref. Provider")}
          name="referringProvider"
          isSelect={true}
          options={providers}
          value={values.referringProvider}
          onChange={handleChange}
          placeholder={t("Please Select Ref. Provider")}
        />

        <CustomFilterInput
          label={t("Priority")}
          name="priority"
          isSelect={true}
          options={priorities}
          value={values.priority}
          onChange={handleChange}
          placeholder={t("Please Select Priority")}
        />
      </div>
    </div>
  );
}

export default PreAuthInfo;
